import { Box, Button, Modal, Paper } from "@mui/material";
import React from "react";
import { useAppSelector } from "../../../app/hooks";
import { selectLabels } from "../../../slices/language";
import { User } from "../../../api/models/user-model";

interface DeleteUserModalProps {
  showDeleteUserModal: boolean;
  setShowDeleteUserModal: (showDeleteUserModal: boolean) => void;
  deleteFunction: () => {};
  userToDelete: User | null;
  setUserToDelete?: (userToDelete: User | null) => void;
}

const DeleteUserModal = ({
  showDeleteUserModal,
  setShowDeleteUserModal,
  deleteFunction,
  userToDelete,
  setUserToDelete,
}: DeleteUserModalProps) => {
  const labels = useAppSelector(selectLabels);

  return (
    <Modal
      open={showDeleteUserModal}
      onClose={() => setShowDeleteUserModal(false)}
    >
      <Box
        style={{
          width: "100%",
          height: "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Paper
          style={{
            maxWidth: 350,
            minWidth: 350,
            width: "40%",
            boxSizing: "border-box",
            paddingTop: 20,
            paddingBottom: 20,
            paddingRight: 30,
            paddingLeft: 30,
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <p style={{ textAlign: "center" }}>
            {labels.delete_user}{" "}
            <span style={{ fontWeight: "bold" }}>{userToDelete?.name}</span>?
          </p>
          <p className="mt-10 red-color" style={{ textAlign: "center" }}>
            {labels.undone_action}
          </p>
          <div className="w-100 flex gap-4 mt-10">
            <Button
              variant="contained"
              fullWidth
              onClick={() => {
                setShowDeleteUserModal(false);
                if (setUserToDelete) {
                  setUserToDelete(null);
                }
              }}
            >
              {labels.cancel}
            </Button>
            <Button variant="contained" fullWidth onClick={deleteFunction}>
              {labels.accept}
            </Button>
          </div>
        </Paper>
      </Box>
    </Modal>
  );
};

export default DeleteUserModal;
